export default ref => {
  function handleMessage(e) {
    if (e.origin !== 'https://cdn.polytwin.com') return

    let copyToClipboard = false

    if (e.data.action === 'setWindowSearchParams') {
      const url = new URL(window.location.pathname, window.location.origin)
      const { searchParams } = e.data

      for (const searchParam in searchParams) {
        url.searchParams.set(searchParam, searchParams[searchParam])

        if (searchParam === 'bimbear_id') {
          copyToClipboard = true
        }
      }

      window.history.replaceState({}, '', url.toString())

      if (copyToClipboard) {
        navigator.clipboard.writeText(url.toString())
      }
    }

    if (e.data.action === 'copyToClipboard') {
      // is never dispatched
    }
  }

  window.addEventListener('message', handleMessage, false)
}
